module.exports = __webpack_public_path__ + "static/media/28.cbe1cc3e.jpg";